import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { dracula } from "react-syntax-highlighter/dist/esm/styles/prism";
import { getFormattedCode } from "../../../utils/post-utils";
import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useState } from "react";

function VersionedCode(props: Props) {
  const versions = props.versions.map((value) => value.type);

  const [version, setVersion] = useState(versions[0]);
  const [option, setOption] = useState(0);

  const content = props.versions.filter((item) => item.type === version)[0];
  const menuVersions = versions.map((item, index) => (
    <MenuItem value={item} key={index}>{item}</MenuItem>
  ));
  const menuOptions = content.options.map((item, index) => (
    <MenuItem value={index + ""} key={index}>{item.type}</MenuItem>
  ));

  function changeVersion(event: SelectChangeEvent) {
    setVersion(event.target.value);
    setOption(0);
  }

  function changeOption(event: SelectChangeEvent) {
    setOption(parseInt(event.target.value));
  }

  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 120 }} size={"small"}>
        <Select
          value={version}
          onChange={changeVersion}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
        >
          {menuVersions}
        </Select>
        <FormHelperText>Select option</FormHelperText>
      </FormControl>
      <FormControl sx={{ m: 1, minWidth: 120 }} size={"small"}>
        <Select
          value={option + ""}
          onChange={changeOption}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
        >
          {menuOptions}
        </Select>
        <FormHelperText>Select version</FormHelperText>
      </FormControl>
      <div>{content.options[option].description}</div>
      <div className={"block-code"}>
        <SyntaxHighlighter
          language={content.options[option].language}
          style={dracula}
        >
          {getFormattedCode(
            content.options[option].language,
            content.options[option].content
          )}
        </SyntaxHighlighter>
      </div>
    </div>
  );
}

export default VersionedCode;

class Props {
  versions: Version[];
}

class Version {
  type: string;

  options: CodeData[];
}

class CodeData {
  type: string;

  language: string;

  content: string;

  description?: string;
}
